/* eslint-disable complexity */
/* eslint-disable max-lines */
/* eslint-disable max-len */
/* eslint-disable max-lines-per-function */
import { connectSMTPSchema } from '../../../schema/integrationSchema';
import { createSMTPIntegrationThunk } from '../../../redux/thunks/integration';
import CustomInput from '../../reusable/input';
import CustomModal from '../../modals';
import { gray } from '../../../theme/themePrimitives';
import ImageClass from '../../../assets';
import { SMTPParams } from '../../../params/redux/integration';
import { useParams } from 'react-router';
import { AppDispatch, RootState } from '../../../redux/store';
import { Box, Button, Typography } from '@mui/material';
import { Form, Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
// import { googleAuthThunk } from '../../../redux/thunks/integration';

const ChooseServiceProviderModal = ({ open, onClose, selectedProvider }: { open: boolean; onClose: () => void, selectedProvider: 'calendar' | 'email' | 'meet' | 'twilio' | 'stripe' | '' }) => {
    const dispatch = useDispatch<AppDispatch>();
    const { id } = useParams();
    const [selectedService, setSelectedService] = useState<string>('');
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const selectedTitle = isLoading
    ? 'Loading'
    : selectedService === 'google' && selectedProvider === 'meet'
    ? 'Connecting your Google Meet'
    : selectedService === 'google' && selectedProvider === 'email'
    ? 'Connecting your Gmail'
    : selectedService === 'google' && selectedProvider === 'calendar'
    ? 'Connecting your Google Calendar'
    : selectedService === 'outlook' && selectedProvider === 'email'
    ? 'Connecting your Outlook Account'
    : selectedService === 'outlook' && selectedProvider === 'calendar'
    ? 'Connecting your Outlook Calendar'
    : selectedService === 'imap'
    ? 'Connect Email with SMTP'
    : 'Choose Service Provider';
    const { token, currentUser } = useSelector((state: RootState) => state.app);
    const { loaders } = useSelector((state: RootState) => state.integration);
    const initialValues: SMTPParams = {
        smtp_host: '',
        smtp_port: 0,
        imap_host: '',
        imap_port: 0,
        username: '',
        password: '',
        email: ''
    };

    const onCloseHandler = () => {
        setSelectedService('');
        onClose();
    };

    useEffect(() => {
        if (selectedProvider === 'meet') {
            setSelectedService('google');
        }
        setIsLoading(false);
    }, [selectedProvider]);

    const continueWithGoogleHandler = () => {
        window.location.href = `${process.env.REACT_APP_API_BASE_URL}auth/google/${token}/${selectedProvider}/${id && (currentUser?.role === 'client') ? 0 : id ? parseInt(id as string, 10) : 0}`;
    };

    const continueWithOutlookHandler = () => {
        window.location.href = `${process.env.REACT_APP_API_BASE_URL}auth/outlook/${token}/${selectedProvider}/${id && (currentUser?.role === 'client') ? 0 : id ? parseInt(id as string, 10) : 0}`;
    };

    const continueWithIMAPHandler = async (values: SMTPParams) => {
        try {
            await dispatch(createSMTPIntegrationThunk({ data: values, paramId: id })).unwrap();
            onCloseHandler();
        } catch (e) {
            // Catch erros
        }
    };

    return (
        <CustomModal open={open} handleClose={onCloseHandler} title={selectedTitle}>
            {isLoading
                ? <></>
                : <Box display="flex" flexDirection="column" width="100%" gap="20px">
                    {selectedService === 'google' && selectedProvider === 'calendar'
                        ? (
                            // Detailed View for Selected Service
                            <Box textAlign="center" maxWidth="500px">
                                <Box mb={2}>
                                    <img
                                        src={ImageClass.googleCalendarLogo}
                                        alt="Google Calendar Logo"
                                        height={80}
                                        width={80}
                                    />
                                </Box>
                                <Typography variant="body1" mb={2}>
                                    Google
                                </Typography>
                                <Typography variant="body1" color="textSecondary" align="left" mb={2}>
                                    When you integrate your Google account with the Gonzy platform, you can connect a number
                                    of Google services to your Gonzy account. By doing so, Gonzy will be able to access data
                                    and information from your Google account. Those services and types of data are outlined
                                    below:
                                </Typography>
                                <Typography variant="body2" color="textSecondary" textAlign="left" mb={2}>
                                    <strong>Google Calendar:</strong> You can use the Meetings tool to create new or modify
                                    existing meetings on your primary Google Calendar.
                                </Typography>
                                <Typography variant="body2" color="textSecondary" mb={2} align="left">
                                    We’ll only use your Google data to power different parts of our product that connect
                                    with the Google Workspace tools you use every day. It’s your data. We just want to help
                                    you grow better.
                                </Typography>
                                <Typography variant="body2" color="textSecondary" mb={2} align="left">
                                    You can revoke Gonzy’s access from within your Google account by following the
                                    instructions listed <a href="#">here</a>.
                                </Typography>
                                <Typography variant="body2" color="textSecondary" mb={3} align="left">
                                    For more information on the Google integration and the types of data we can access,
                                    please see our <a href="#">Privacy Policy</a>.
                                </Typography>
                                <Button
                                    variant="outlined"
                                    startIcon={<img src={ImageClass.googleLogo} alt="Google" height={24} />}
                                    color="secondary"
                                    onClick={continueWithGoogleHandler}
                                >
                                    Continue with Google
                                </Button>
                            </Box>
                        )
                        : selectedService === 'google' && selectedProvider === 'email'
                        ? (
                            // Detailed View for Selected Service
                            <Box textAlign="center" maxWidth="500px">
                                <Box mb={2}>
                                    <img
                                        src={ImageClass.emailIntegration}
                                        alt="Google Calendar Logo"
                                        height={80}
                                        width={80}
                                    />
                                </Box>
                                <Typography variant="body1" mb={2}>
                                    Google
                                </Typography>
                                <Typography variant="body1" color="textSecondary" align="left" mb={2}>
                                    When you integrate your Google account with the Gonzy platform, you can connect Gmail services
                                    to your Gonzy account. By doing so, Gonzy will be able to access email data from your Gmail account
                                    using Google&apos;s secure APIs. The types of data and actions we may perform are outlined below:
                                </Typography>
                                <Typography variant="body2" color="textSecondary" textAlign="left" mb={2}>
                                    <strong>Gmail Access:</strong> You can send and receive emails using your connected Gmail account
                                    directly from Gonzy. This includes viewing inbox messages, reading threads, and composing emails
                                    based on the permissions you approve.
                                </Typography>
                                <Typography variant="body2" color="textSecondary" mb={2} align="left">
                                    We’ll only use your Gmail data to power features like communication automation, email templates, and workflow triggers. We do not store or share your email data outside your Gonzy account. It’s your data — we only use it to help you work better.
                                </Typography>
                                <Typography variant="body2" color="textSecondary" mb={2} align="left">
                                    You can revoke Gonzy’s access at any time via your Google Account’s security settings by following the instructions listed here.
                                </Typography>
                                <Typography variant="body2" color="textSecondary" mb={3} align="left">
                                    For more information, please review our Privacy Policy and Google’s User Data Policy.<a href="#">Privacy Policy</a>.
                                </Typography>
                                <Button
                                    variant="outlined"
                                    startIcon={<img src={ImageClass.googleLogo} alt="Google" height={24} />}
                                    color="secondary"
                                    onClick={continueWithGoogleHandler}
                                >
                                    Continue with Google
                                </Button>
                            </Box>
                        )
                        : selectedService === 'google' && selectedProvider === 'meet'
                        ? (
                            // Detailed View for Selected Service
                            <Box textAlign="center" maxWidth="500px">
                                <Box mb={2}>
                                    <img
                                        src={ImageClass.googleCalendarLogo}
                                        alt="Google Calendar Logo"
                                        height={80}
                                        width={80}
                                    />
                                </Box>
                                <Typography variant="body1" mb={2}>
                                    Google
                                </Typography>
                                <Typography variant="body1" color="textSecondary" align="left" mb={2}>
                                    When you integrate your Google account with the Gonzy platform, you can connect Google Meet services to your Gonzy account. By doing so, Gonzy will be able to access and manage meeting-related data using your Google Calendar and Meet integration.
                                </Typography>
                                <Typography variant="body2" color="textSecondary" textAlign="left" mb={2}>
                                    <strong>Google Meet Access:</strong> You can use Gonzy to schedule, create, and manage Google Meet video calls. These meetings will be automatically linked to your Google Calendar events.
                                </Typography>
                                <Typography variant="body2" color="textSecondary" mb={2} align="left">
                                    Gonzy will only access your calendar and meeting data to facilitate scheduling and joining meetings through the platform. No other data from your Google account will be accessed or shared without your permission.
                                </Typography>
                                <Typography variant="body2" color="textSecondary" mb={2} align="left">
                                    You can revoke Gonzy’s access at any time from your Google Account settings by following the steps outlined here.
                                </Typography>
                                <Typography variant="body2" color="textSecondary" mb={3} align="left">
                                    For more information on the types of data we access and how we handle it, please see our Privacy Policy. <a href="#">Privacy Policy</a>.
                                </Typography>
                                <Button
                                    variant="outlined"
                                    startIcon={<img src={ImageClass.googleLogo} alt="Google" height={24} />}
                                    color="secondary"
                                    onClick={continueWithGoogleHandler}
                                >
                                    Continue with Google
                                </Button>
                            </Box>
                        )
                        : selectedService === 'outlook' && (selectedProvider === 'email' || selectedProvider === 'calendar')
                            ? (
                                <Box textAlign="center" maxWidth="500px">
                                    <Box mb={2}>
                                        <img
                                            src={ImageClass.outlookLogo}
                                            alt="Outlook Logo"
                                            height={80}
                                            width={80}
                                        />
                                    </Box>
                                    <Typography variant="body1" mb={2}>
                                        Outlook
                                    </Typography>
                                    <Typography variant="body1" color="textSecondary" align="left" mb={2}>
                                        First, by granting Gonzy access to your inbox, your Gonzy will be able to locate relevant email conversations and log them in your CRM so you and your team can work on them together. Emails that you send from Gonzy will also appear in your Outlook sent folder, so there&apos;ll be no confusion about which emails live where.
                                    </Typography>
                                    <Typography variant="body2" color="textSecondary" textAlign="left" mb={2}>
                                        This means that your Gonzy will have access to some information about your emails, like the email address you&apos;re sending them from, the email addresses of your recipients, what&apos;s in the subject line, and what&apos;s in the body of the email. We&apos;ll only use that access to power your Gonzy Outlook integration and make life easier for you, never for any nefarious purposes of our own. It&apos;s your data. We just want to help you use it better. You&apos;ll always be able to delete specific email records from your CRM with just a couple of clicks.
                                    </Typography>
                                    <Button
                                        variant="contained"
                                        onClick={continueWithOutlookHandler}
                                    >
                                        Continue
                                    </Button>
                                </Box>
                            )
                            : selectedService === 'imap' && selectedProvider === 'email'
                                ? (<>
                                    <Formik
                                        initialValues={initialValues}
                                        validationSchema={connectSMTPSchema}
                                        onSubmit={continueWithIMAPHandler}
                                    >
                                        {({ values, handleChange, handleBlur, errors, touched }) => (
                                            <Form>
                                                <Box display="flex" flexDirection="column" gap={1} width="100%">
                                                    <CustomInput
                                                        value={values.smtp_host}
                                                        onChange={handleChange('smtp_host')}
                                                        onBlur={handleBlur('smtp_host')}
                                                        error={touched.smtp_host && errors.smtp_host}
                                                        fullWidth
                                                        label="SMTP Host"
                                                        placeholder="Type here"
                                                        variant="outlined"
                                                        mandatoryFields={true}
                                                    />
                                                    {/* Input field for default deal value */}
                                                    <CustomInput
                                                        type="number"
                                                        value={values.smtp_port}
                                                        onChange={handleChange('smtp_port')}
                                                        onBlur={handleBlur('smtp_port')}
                                                        error={touched.smtp_port && errors.smtp_port}
                                                        fullWidth
                                                        label="SMTP Port"
                                                        placeholder="Type here"
                                                        variant="outlined"
                                                        mandatoryFields={true}
                                                    />
                                                    <CustomInput
                                                        value={values.imap_host}
                                                        onChange={handleChange('imap_host')}
                                                        onBlur={handleBlur('imap_host')}
                                                        error={touched.imap_host && errors.imap_host}
                                                        fullWidth
                                                        label="IMAP Host"
                                                        placeholder="Type here"
                                                        variant="outlined"
                                                        mandatoryFields={true}
                                                    />
                                                    <CustomInput
                                                        type="number"
                                                        value={values.imap_port}
                                                        onChange={handleChange('imap_port')}
                                                        onBlur={handleBlur('imap_port')}
                                                        error={touched.imap_port && errors.imap_port}
                                                        fullWidth
                                                        label="IMAP Port"
                                                        placeholder="IMAP Port"
                                                        variant="outlined"
                                                    />
                                                    <CustomInput
                                                        value={values.username}
                                                        onChange={handleChange('username')}
                                                        onBlur={handleBlur('username')}
                                                        error={touched.username && errors.username}
                                                        fullWidth
                                                        label="Username"
                                                        placeholder="Username"
                                                        variant="outlined"
                                                    />
                                                    <CustomInput
                                                        value={values.password}
                                                        onChange={handleChange('password')}
                                                        onBlur={handleBlur('password')}
                                                        error={touched.password && errors.password}
                                                        fullWidth
                                                        label="Password"
                                                        placeholder="Password"
                                                        variant="outlined"
                                                    />
                                                    <CustomInput
                                                        value={values.email}
                                                        onChange={handleChange('email')}
                                                        onBlur={handleBlur('email')}
                                                        error={touched.email && errors.email}
                                                        fullWidth
                                                        label="Email"
                                                        placeholder="Email"
                                                        variant="outlined"
                                                    />

                                                    <Button variant="text" onClick={() => window.open('https://gonzy.zendesk.com/hc/en-us/articles/26348793205531-Email-SMTP-IMAP', '_blank')}>How to connect your email with SMTP?</Button>
                                                    {/* Action buttons for form submission or cancellation */}
                                                    <Box display="flex" gap={2} mt={2}>
                                                        <Button variant="outlined" color="primary" onClick={onCloseHandler} fullWidth disabled={loaders.isCreating}>
                                                            Cancel
                                                        </Button>
                                                        <Button type="submit" variant="contained" color="primary" fullWidth disabled={loaders.isCreating}>
                                                            {loaders.isCreating ? 'Saving...' : 'Save'}
                                                        </Button>
                                                    </Box>
                                                </Box>
                                            </Form>
                                        )}
                                    </Formik>
                                </>)
                                : (
                                    // Selection View
                                    <Box display="flex" gap={2} justifyContent="center">
                                        {(selectedProvider === 'email' || selectedProvider === 'calendar') && <Box
                                            display="flex"
                                            flexDirection="column"
                                            alignItems="center"
                                            gap="10px"
                                            width="max-content"
                                            border="1px solid rgba(235, 235, 235, 0.92)"
                                            p={2}
                                            borderRadius="10px"
                                            sx={{
                                                '&:hover': {
                                                    backgroundColor: gray[100],
                                                    cursor: 'pointer'
                                                }
                                            }}
                                            onClick={() => setSelectedService('google')}
                                        >
                                            <img
                                                src={selectedProvider === 'email' ? ImageClass.emailIntegration : ImageClass.googleCalendarLogo}
                                                alt="Google Calendar Logo"
                                                height={80}
                                                width={80}
                                            />
                                            <Typography variant="subtitle1">Google</Typography>
                                        </Box>}
                                        {(selectedProvider === 'email' || selectedProvider === 'calendar') && <Box
                                            display="flex"
                                            flexDirection="column"
                                            alignItems="center"
                                            gap="10px"
                                            width="max-content"
                                            border="1px solid rgba(235, 235, 235, 0.92)"
                                            p={2}
                                            borderRadius="10px"
                                            sx={{
                                                '&:hover': {
                                                    backgroundColor: gray[100],
                                                    cursor: 'pointer'
                                                }
                                            }}
                                            onClick={() => setSelectedService('outlook')}
                                        >
                                            <img
                                                src={ImageClass.outlookLogo}
                                                alt="Google Calendar Logo"
                                                height={80}
                                                width={80}
                                            />
                                            <Typography variant="subtitle1">Outlook</Typography>
                                        </Box>}
                                        {selectedProvider === 'email' && <Box
                                            display="flex"
                                            flexDirection="column"
                                            alignItems="center"
                                            gap="10px"
                                            width="max-content"
                                            border="1px solid rgba(235, 235, 235, 0.92)"
                                            p={2}
                                            borderRadius="10px"
                                            sx={{
                                                '&:hover': {
                                                    backgroundColor: gray[100],
                                                    cursor: 'pointer'
                                                }
                                            }}
                                            onClick={() => setSelectedService('imap')}
                                        >
                                            <img
                                                src={ImageClass.smtpLogo}
                                                alt="Google Calendar Logo"
                                                height={80}
                                                width={80}
                                            />
                                            <Typography variant="subtitle1">SMTP & IMAP</Typography>
                                        </Box>}
                                    </Box>
                                )}
                </Box>}
        </CustomModal>
    );
};

export default ChooseServiceProviderModal;
